<template>
	<div class="form-group">
		<template v-if="required">
			<label class="form-label">{{ label }} <span class="text-danger">*</span></label>
			<ckeditor :editor="editor" :config="editorConfig" :name="name" v-model="inputData" @ready="onEditorReady" @destroy="onEditorDestroy" v-validate="'required'"></ckeditor>
			<small class="d-block text-danger">{{ errors.first(name) }}</small>
		</template>
		<template v-else>
			<label class="form-label">{{ label }}</label>
			<ckeditor :editor="editor" :config="editorConfig" :name="name" v-model="inputData" @ready="onEditorReady" @destroy="onEditorDestroy"></ckeditor>
		</template>
	</div>
</template>

<script>
// @ is an alias to /src
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
	name: 'TextEditor',
	inject: ['$validator'],
	components: {
		// Use the <ckeditor> component in this view.
		ckeditor: CKEditor.component
	},
	props: {
		data: String,
		name: String,
		label: String,
		required: Boolean
	},
	data() {
		return {
			inputData: "",
			editor: ClassicEditor,
			editorData: '',
			editorConfig: {
				removePlugins: [ 'ImageUpload', 'MediaEmbed', 'blockQuote' ],
				toolbar: [  'Heading', 'bold', 'italic', 'Link', 'bulletedList', 'numberedList', 'undo', 'redo' ]
			},
			isEditorReady: false
		}
	},
	mounted() {
		this.$root.$on('reset-validation', () => {
			// Reset Vee Validate
			this.$validator.reset();
		});
	},
	methods: {
		onEditorReady: function() {
			this.isEditorReady = true;
			this.inputData = this.data;
		},
		onEditorDestroy: function() {
			this.isEditorReady = false;
		}
	},
	watch: {
		inputData: {
			handler: function() {
				this.$emit('update:value', this.inputData)
			},
			deep: true
		},
		data: function() {
			if(this.isEditorReady) {
				this.inputData = this.data;
			}
		}
	}
}
</script>